import React from 'react';
import { AlertTriangle, Clock, LogOut, RefreshCw } from 'lucide-react';
import styles from './IdleWarningModal.module.css';

/**
 * Idle Warning Modal
 *
 * Displays when user has been inactive for 30 minutes
 * Shows 60 second countdown before automatic logout
 * Allows user to stay logged in
 */
const IdleWarningModal = ({ show, countdown, onStayLoggedIn, onLogout }) => {
  if (!show) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Icon */}
        <div className={styles.iconContainer}>
          <div className={styles.iconCircle}>
            <AlertTriangle size={40} className={styles.icon} />
          </div>
        </div>

        {/* Title */}
        <h2 className={styles.title}>Session Timeout Warning</h2>

        {/* Message */}
        <p className={styles.message}>
          You have been inactive for 30 minutes. For your security, you will be automatically logged out in:
        </p>

        {/* Countdown */}
        <div className={styles.countdown}>
          <Clock size={24} className={styles.countdownIcon} />
          <span className={styles.countdownText}>{countdown} seconds</span>
        </div>

        {/* Buttons */}
        <div className={styles.buttons}>
          <button
            className={styles.stayButton}
            onClick={onStayLoggedIn}
            autoFocus
          >
            <RefreshCw size={18} />
            Stay Logged In
          </button>

          <button
            className={styles.logoutButton}
            onClick={onLogout}
          >
            <LogOut size={18} />
            Logout Now
          </button>
        </div>

        {/* Security Note */}
        <p className={styles.securityNote}>
          This is a security measure to protect your account from unauthorized access.
        </p>
      </div>
    </div>
  );
};

export default IdleWarningModal;
